<div class="container">
    <h2 class="heading">Generate Teltonika Report</h2>
    <div class="dates-container">
        <mat-form-field class="dates" matError>
            <mat-label>Choose a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input #input1 matStartDate [formControl]="startDateControl">
                <input #input2 [formControl]="endDateControl" matEndDate>
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            @if(startDateControl.hasError('required') || endDateControl.hasError('required')) {
            <mat-error>Date missing from selection</mat-error>
            }
        </mat-form-field>
    </div>
    @if(!allSelected) {
    <tools-table #selectedDevicesTable [Data]="devices" [Headers]="headers" [Search]="false" [Slim]="true"
        [SortColumn]="'id'"></tools-table>
    }
    <div class="buttons">
        <button mat-raised-button (click)="close(true)">Generate Report</button>
        <button mat-raised-button (click)="close(false)">Cancel</button>
    </div>

</div>